import type { IContentResult } from '@quesmed/types/models';
import { GiPartyPopper } from 'react-icons/gi';
import { Snippet } from '@/core/ui';

type FeedbackProps = {
  response?: Partial<IContentResult>;
  overWrite?: boolean;
  showBatch?: boolean;
  plain?: boolean;
  symbol?: string;
  message?: string;
};

export const SuccessFeedback = ({
  message,
  response,
  overWrite = false,
  plain = false,
  symbol = 'Batch Id:',
  showBatch = true,
}: FeedbackProps) => {
  const batchMessage = overWrite ? 'Use same batchId to overwrite' : 'Use above batchId for import';

  if (plain) {
    return (
      <div className='flex space-x-2 items-center'>
        <GiPartyPopper className='text-yellow-600 w-8 h-8' />
        <span>{message || `Yay! Content is validated and bug free! ${batchMessage}`}</span>
      </div>
    );
  }

  return (
    <>
      {showBatch && (
        <Snippet
          tooltipProps={{
            content: 'Copy',
            placement: 'right',
          }}
          size='md'
          color='success'
          symbol={symbol}
        >
          {response?.batchId}
        </Snippet>
      )}
      <div className='flex space-x-2 items-center'>
        <GiPartyPopper className='text-yellow-600 w-8 h-8' />
        <span>{message || `Yay! Content is validated and bug free! ${batchMessage}`}</span>
      </div>
    </>
  );
};
